import { render, staticRenderFns } from "./BannerHeading.vue?vue&type=template&id=695e2b44"
import script from "./BannerHeading.vue?vue&type=script&lang=js"
export * from "./BannerHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports